import { get, mapValues, omit } from 'lodash';

import * as actions from '../actions/query-actions';

const getInlineKey = id => `queries.query-${id}`;

const DEFAULT_QUERY = { loading: false, data: [] };
const FAILED_QUERY = 'failed';
const PENDING_QUERY = 'pending';
const SUCCESS_QUERY = 'success';

export default function queries(
  state = { inline: {}, saved: {}, status: {} },
  action = {}
) {
  switch (action.type) {
    case actions.INLINE_QUERY_REQUEST: {
      const queryKey = getInlineKey(action.id);

      if (get(state.inline, queryKey, false)) {
        return {
          ...state,
          inline: omit(state.inline, queryKey),
          status: {
            ...state.status,
            [queryKey]: PENDING_QUERY
          }
        };
      }

      return {
        ...state,
        status: {
          ...state.status,
          [getInlineKey(action.id)]: PENDING_QUERY
        }
      };
    }

    case actions.INLINE_QUERY_SUCCESS:
      return {
        ...state,
        inline: {
          ...state.inline,
          [getInlineKey(action.id)]: action.result
        },
        status: {
          ...state.status,
          [getInlineKey(action.id)]: SUCCESS_QUERY
        }
      };

    case actions.INLINE_QUERY_ERROR:
      return {
        ...state,
        status: {
          ...state.status,
          [getInlineKey(action.id)]: FAILED_QUERY
        }
      };
    case actions.INLINE_QUERY_RESULTS_RESET: {
      return {
        ...state,
        inline: {
          ...state.inline,
          [getInlineKey(action.id)]: DEFAULT_QUERY
        },
        status: {
          ...state.status,
          [getInlineKey(action.id)]: undefined
        }
      }
    }

    default:
      return state;
  }
}

export const getInlineQueryStatus = (id, state) =>
  get(state, ['queries', 'status', getInlineKey(id)], PENDING_QUERY);

export const getInlineQueryResult = (id, state) => ({
  ...get(state, ['queries', 'inline', getInlineKey(id)], DEFAULT_QUERY),
  loading: getInlineQueryStatus(id, state) === PENDING_QUERY
});

export const getInlineQueryResults = (queriesConfig, state) =>
  mapValues(queriesConfig, (_, name) => getInlineQueryResult(name, state));
